require('./bootstrap');
import 'alpinejs';